@if (_filterMenu) {
  <div class="menu">
    <div>
      <span>{{ _filterMenu.title }}</span>
      <span class="pull-right">{{ _filterMenu.count }}</span>
    </div>
    <div class="nav-list">
      @for (item of _filterMenu.items; track item) {
        <div [class.active]="item.id === selectedItem.id" (click)="menuClick(item)" title="{{ item.tooltip }}">
          <!--<i *ngIf="item.rag === 'red' || item.rag === 'amber'" class="fa fa-circle x-rag-{{item.rag}}"></i>-->
          <span>{{ item.title }}</span>
          @if (item.count !== null) {
            <span class="pull-right counter">{{ item.count }}</span>
          }
        </div>
      }
    </div>
  </div>
}
